import { drawerWidth, collapsedDrawerWidth, desktopRailWidth } from './styles'

export const getSidebarLayoutWidth = (
  theme,
  { isDesktopNav, isCollapsibleSidebar, isNavCollapsed },
) => {
  if (isDesktopNav) {
    return isNavCollapsed ? desktopRailWidth : drawerWidth
  }

  if (isCollapsibleSidebar) {
    return isNavCollapsed ? collapsedDrawerWidth(theme) : drawerWidth
  }

  return 0
}

export const shouldShowNavLabels = ({ isMobileNav, isNavCollapsed }) =>
  isMobileNav || !isNavCollapsed

const NAV_COLLAPSED_STORAGE_KEY = 'appShell.navCollapsed'

export const readStoredNavCollapsed = () => {
  try {
    return window.localStorage.getItem(NAV_COLLAPSED_STORAGE_KEY) === 'true'
  } catch (e) {
    return false
  }
}

export const storeNavCollapsed = collapsed => {
  try {
    window.localStorage.setItem(NAV_COLLAPSED_STORAGE_KEY, String(collapsed))
  } catch (e) {
    // Storage can be unavailable (private mode, quotas); the preference is
    // then simply session-only.
  }
}
